<!--用户页 普通用户数据表-->
<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="ordinaryData"
            class="elevation-1"
            disable-sort
            loading-text="数据加载中..."
            no-data-text="查询不到数据"
            :server-items-length="totalCount"
            :options.sync="options"
            :footer-props="footerProps"
            :dark="theme.tableDark"
        >
            <template v-slot:item.avatar="{ item }">
                <v-avatar size="40">
                    <img :src="'http://www.meisenpay.com/' + item.avatar" />
                </v-avatar>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            headers: [
                { text: "编号", value: "id" },
                { text: "头像", value: "avatar" },
                { text: "用户名", value: "name" },
                { text: "手机号", value: "phone" },
                { text: "账户余额", value: "balance" },
                { text: "最近一次使用", value: "lastTime" },
            ],
            totalCount: 1000,
            footerProps: {
                itemsPerPageText: "每页显示数目",
                itemsPerPageOptions: [5, 10, 15],
                showCurrentPage: true,
                showFirstLastPage: true,
            },
            options: {}, //外部控制分页
        };
    },
    props: {
        ordinaryData: Array,
    },
    computed: {
        ...mapState(["theme"]),
    },
    methods: {
        toUserInfo(item) {
            this.$router.push({
                name: "UserInfo",
                params: { id: item.id },
            });
        },
    },
};
</script>
